import { useState } from "react";


export const useOneTimePassStates = () => {
  // ユーザー入力値
  const [inputPass, setInputPass] = useState("");
  // 画像ボックス表示フラグ
  const [isActiveImageBox, setIsActiveImageBox] = useState(false);
  // テキストボックス表示フラグ
  const [isActiveTextBox, setIsActiveTextBox] = useState(false);
  // 確認するボタン有効化フラグ
  const [validConfirmButton, setIsValidConfirmButton] = useState(false);

  return {
    inputPass,
    setInputPass,
    isActiveImageBox,
    setIsActiveImageBox,
    isActiveTextBox,
    setIsActiveTextBox,
    validConfirmButton,
    setIsValidConfirmButton,
  };
};
